import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing version licence.
 */
interface ListVersionLicenceRequest {
  queryKey: [number, string];
}

/**
 * Service class for handling products types.
 */
class LicenceVersionService {
  static listVersionLicence(request: ListVersionLicenceRequest) {
    const page_no = request.queryKey[0];
    const searchText = request.queryKey[1];
    return client.get(
      `admin/licence/version/list?page=${page_no}&search_text=${searchText}`,
      request as AxiosRequestConfig
    );
  }

  /**
   * Adds a new version licence based on the provided request.
   *
   * @param request - The request parameters for adding a version licence.
   * @returns A Promise that resolves to the Axios response for the add version licence request.
   */
  static addVersionLicence(request: any) {
    return client.post(`admin/licence/version/add`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }

  /**
   * Retrieves the details of a Version based on the provided parameters.
   *
   * @param params - The parameters for retrieving the Version details.
   * @returns A Promise that resolves to the Axios response containing the Version details.
   */
  static viewVersionLicence(params: any) {
    return client.get("admin/licence/version/get", { params });
  }

  /**
   * Updates the details of a version licence based on the provided request.
   *
   * @param request - The request parameters for updating a version licence.
   * @returns A Promise that resolves to the Axios response for the update version licence request.
   */
  static updateVersionLicence(request: any) {
    return client.post(`admin/licence/version/edit`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }

  /**
   * Deletes a version licence based on the provided parameters.
   *
   * @param params - The parameters for deleting the version licence.
   * @returns A Promise that resolves to the Axios response for the delete version licence request.
   */
  static deleteVersionLicence(params: any) {
    return client.delete("admin/licence/version/delete/", { params });
  }
}

export { LicenceVersionService };
